export interface ISortBy {
    property: string,
    direction: string
}